import { useState } from "react";
import { useSelector } from "react-redux";

import Mini from "@/components/common/product/mini";
import CheckboxNew from "~/components/common/checkboxNew";

import PopupFormWrapper from "../popupFormWrapper";
import { GOALS } from "../../../../utils/tracking";

const FORM_CODE = "buyOneClick";

export default function BuyOneClick() {
  const { cityName, deliveryCityData } = useSelector((state) => state.location);
  const { data } = useSelector((state) => state.popup);

  const [isNeedInstall, setIsNeedInstall] = useState(false);

  return (
    <PopupFormWrapper
      code={FORM_CODE}
      goalOpen={GOALS.buyOneClickOpen}
      goalSent={GOALS.buyOneClickSent}
      filterField={({ CODE }) => CODE !== "form_text_105"}
      extraData={({ popupData }) => ({
        PRODUCT_ID: popupData?.id,
        NEED_INSTALL: isNeedInstall ? 1 : 0,
        CITY: `${cityName}, ${deliveryCityData?.region_with_type || ""}`,
      })}
      successText={(r) => `Заявка отправлена. Номер вашей заявки #${r.success}`}
    >
      {data?.id && <Mini productId={data.id} />}
      {["Москва", "Санкт-Петербург"].includes(cityName) && (
        <CheckboxNew
          onChange={() => setIsNeedInstall((v) => !v)}
          checked={isNeedInstall}
          label="Добавить услугу установки"
        />
      )}
    </PopupFormWrapper>
  );
}
